/* Tabs.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1xC2CJZeqy%7Bgrid-area%3Atabs%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
import React from 'react';
import Box from '@atlaskit/primitives/box';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled/box';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { fg } from '@townsquare/stat-sig/gate';
const styles = xcss({
  marginBlockStart: 'space.100',
  marginInline: 'space.negative.300',
  /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
  // @ts-expect-error - Remove bottom border on platform tabs via nested style as there's no other way to do this currently
  'nav::before': {
    display: 'none'
  }
  /* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles */
});
const wrapperStyles = xcss({
  gridArea: 'tabs',
  overflowX: 'hidden',
  overflowY: 'hidden'
});
const compiledWrapperStyles = {
  root: "_1xC2CJZeqy _4bt5LAnQyn _2WAcuGnQyn"
};
export const Tabs = ({
  children
}: React.PropsWithChildren<unknown>): React.JSX.Element => {
  return fg('townsquare-compiled-xcss-to-cssmap') ? <CompiledBox xcss={compiledWrapperStyles.root}>
			<Box xcss={styles}>{children}</Box>
		</CompiledBox> : <Box xcss={wrapperStyles}>
			<Box xcss={styles}>{children}</Box>
		</Box>;
};